import AvatarPlaceholder from 'common/AvatarPlaceholder/AvatarPlaceholder';
import { resolveDanceClass } from 'services/EphanDataService';
import '../../Catalog.css';
import './DancerCard.css';
import './Colors.css';
import { useLanguage } from 'hooks/useLanguage';

/**
 * Картка танцюриста — ADR-0015.
 *
 * Клуб із картки прибрано: у записі реєстру його більше немає. Дізнатися клуб
 * танцюриста можна лише зворотним ходом — попросити склад конкретного клубу
 * (`/dancers?clubId=`), — тож у переліку його показати нема з чого. Тому клуб
 * лишився фільтром, а не підписом.
 */
export default function DancerCard({ dancer }) {
  const language = useLanguage();

  const surname = (dancer.surname || '').trim();
  const name = (dancer.name || '').trim();

  const danceClass = resolveDanceClass(dancer.danceClass);
  const classLabel = danceClass ? (language === 'en' ? danceClass.shortLabel : danceClass.shortLabelUa) : '';

  return (
    <div className='catalog-card dancer-card'>
      <div className='img-wrapper'>
        {dancer.avatar ? (
          <img className='dancer-img' src={`${dancer.avatar}?q=20&auto=format`} alt='' loading='lazy' />
        ) : (
          <AvatarPlaceholder />
        )}
      </div>

      <div className='card-body'>
        <h2 className='card-name'>
          {surname} {name}
        </h2>

        {classLabel && (
          <span className={`dancer-class ${danceClass.code}`}>
            <span className='visually-hidden'>{language === 'en' ? 'Class: ' : 'Клас: '}</span>
            {classLabel}
          </span>
        )}
      </div>
    </div>
  );
}
